import { CoordWaypoint, Waypoint } from '@/domain/models'
import { Coordinates } from '@/domain/protocols/Coordinates'

import { RouterPaths } from '@/presentation/router/RouterPathsMapper'
import { convertDecimalDegreesToDMS } from '@/utils/coordinates'

export function isGenericCoordWaypoint(waypoint: Waypoint): waypoint is CoordWaypoint {
  return waypoint instanceof CoordWaypoint && !waypoint.extra?.isUserWaypoint && !waypoint.extra?.isAddress
}

export function getCreateUserWaypointPath(coordinates: Coordinates): string {
  const coords = encodeURIComponent(convertDecimalDegreesToDMS(coordinates.latitude, coordinates.longitude))

  return `${RouterPaths.MY_CONTENT}/${RouterPaths.MY_CONTENT__USER_WAYPOINTS}/${RouterPaths.MY_CONTENT__USER_WAYPOINTS__CREATE}?coords=${coords}`
}

export function getEditUserWaypointPath(waypoint: CoordWaypoint): string {
  // O nome e o id vão no path da URL, então precisam ser codificados para evitar que caracteres
  // especiais (ex.: a barra "/" em um nome de ponto) sejam interpretados como separadores de segmento.
  const name = encodeURIComponent(waypoint.customName ?? '')
  const id = encodeURIComponent(waypoint.id.toString())
  const coords = encodeURIComponent(
    convertDecimalDegreesToDMS(waypoint.coordinates.latitude, waypoint.coordinates.longitude)
  )

  return `${RouterPaths.MY_CONTENT}/${RouterPaths.MY_CONTENT__USER_WAYPOINTS}/edit/${name}/${id}?coords=${coords}`
}
